export enum Status {
    NotConfirmed = 'NOT_CONFIRMED', 
    Upcoming = 'UPCOMING', 
    Confirmed = 'CONFIRMED',
    Cancelled = 'CANCELLED',
    Rejected = 'REJECTED',
    Completed = 'COMPLETED',
}
